import { DEFAULT_STATE } from './constants'

export default {
  ...DEFAULT_STATE,
}
